import useController from '@common/hooks/useController'

// Native shim — read state from in-process ControllerStore.
// Web variant relies on `PortfolioControllerStateProvider` not mounted on RN.
export default function usePortfolioControllerState(): any {
  const { state } = useController('PortfolioController' as any)
  return state as any
}
